import Vue from 'vue';
import VueRouter from 'vue-router';

import constants from 'august-constants';

import Account from '../views/Account.vue';
import BillsView from '../views/BillsView.vue';
import Credentials from '../views/Credentials.vue';
import Documentation from '../views/Documentation.vue';
import LayoutLoggedIn from '../layouts/LoggedIn.vue';
import LayoutNotLoggedIn from '../layouts/NotLoggedIn.vue';
import Links from '../views/Links.vue';
import Login from '../views/Login.vue';
import Overview from '../views/Overview.vue';
import Partner from '../views/Partner.vue';
import Partners from '../views/Partners.vue';
import PartnersNew from '../views/PartnersNew.vue';
import OperationHistory from '../views/OperationHistory';
import Register from '../views/Register.vue';
import ResetPassword from '../views/ResetPassword.vue';
import Users from '../views/Users.vue';
import VerificationCode from '../views/VerificationCode.vue';
import VerificationEmail from '../views/VerificationEmail.vue';
import OtherDocumentation from '../views/OtherDocumentation.vue';
import PartnerApiCallLimits from '../views/PartnerApiCallLimits.vue';
import IntegrationCertification from '../views/IntegrationCertification.vue';
import MarketBrandGuidelines from '../views/MarketBrandGuidelines.vue';
import ReonboardPortal from '../views/ReonboardPortal.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/links',
    name: 'Links',
    component: Links,
    meta: {
      layout: LayoutLoggedIn,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      layout: LayoutNotLoggedIn,
      overrideAuth: true,
    },
  },
  {
    path: '/',
    name: 'Index',
    component: Login,
    meta: {
      layout: LayoutNotLoggedIn,
      overrideAuth: true,
    },
  },
  {
    path: '/verification/email',
    name: 'VerificationEmail',
    component: VerificationEmail,
    meta: {
      layout: LayoutNotLoggedIn,
      overrideAuth: true,
    },
  },
  {
    path: '/verification/code',
    name: 'VerificationCode',
    component: VerificationCode,
    meta: {
      layout: LayoutNotLoggedIn,
      overrideAuth: true,
    },
  },
  {
    path: '/resetpassword',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      layout: LayoutNotLoggedIn,
      overrideAuth: true,
    },
  },
  {
    path: '/register/:email/:invitationID',
    name: 'Register',
    component: Register,
    meta: {
      layout: LayoutNotLoggedIn,
      overrideAuth: true,
    },
  },
  {
    path: '/overview',
    name: 'Overview',
    component: Overview,
    meta: {
      layout: LayoutLoggedIn,
    },
  },
  {
    path: '/credentials',
    name: 'Credentials',
    component: Credentials,
    meta: {
      layout: LayoutLoggedIn,
      roles: [constants.DeveloperRoles.PARTNER_ADMIN],
    },
  },
  {
    path: '/users',
    name: 'Users',
    component: Users,
    meta: {
      layout: LayoutLoggedIn,
      roles: [constants.DeveloperRoles.PARTNER_ADMIN],
    },
  },
  {
    path: '/bills',
    name: 'BillsView',
    component: BillsView,
    meta: {
      layout: LayoutLoggedIn,
      roles: [constants.DeveloperRoles.PARTNER_ADMIN],
    },
  },
  {
    path: '/partners',
    name: 'Partners',
    component: Partners,
    meta: {
      layout: LayoutLoggedIn,
      roles: [constants.DeveloperRoles.GLOBAL_ADMIN],
    },
  },
  {
    path: '/partners/:partnerID',
    name: 'Partner',
    component: Partner,
    meta: {
      layout: LayoutLoggedIn,
      roles: [constants.DeveloperRoles.GLOBAL_ADMIN],
    },
  },
  {
    path: '/partners/new',
    name: 'PartnersNew',
    component: PartnersNew,
    meta: {
      layout: LayoutLoggedIn,
      roles: [constants.DeveloperRoles.GLOBAL_ADMIN],
    },
  },
  {
    path: '/operation-history/:partnerID',
    name: 'OperationHistory',
    component: OperationHistory,
    meta: {
      layout: LayoutLoggedIn,
      roles: [constants.DeveloperRoles.GLOBAL_ADMIN],
    },
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: {
      layout: LayoutLoggedIn,
    },
  },
  {
    path: '/docs/:url',
    name: 'Documentation',
    component: Documentation,
    meta: {
      layout: LayoutLoggedIn,
    },
  },
  {
    path: '/other-documentation',
    name: 'OtherDocumentation',
    component: OtherDocumentation,
    meta: {
      layout: LayoutLoggedIn,
    },
  },
  {
    path: '/partner-api-call-limits',
    name: 'PartnerApiCallLimits',
    component: PartnerApiCallLimits,
    meta: {
      layout: LayoutLoggedIn,
    },
  },
  {
    path: '/api-integration-certification',
    name: 'IntegrationCertification',
    component: IntegrationCertification,
    meta: {
      layout: LayoutLoggedIn,
    },
  },
  {
    path: '/market-brand-guidelines',
    name: 'MarketBrandGuidelines',
    component: MarketBrandGuidelines,
    meta: {
      layout: LayoutLoggedIn,
    },
  },
  {
    path: '/reonboard-portal-process',
    name: 'ReonboardPortal',
    component: ReonboardPortal,
    meta: {
      layout: LayoutLoggedIn,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // TODO: Use the Vue.js store instead of local storage.
  const loggedIn = Number(localStorage.getItem('loggedIn'));
  if (!loggedIn && !to.meta.overrideAuth) {
    return next({ name: 'Index' });
  }
  if (loggedIn && (to.name === 'Index' || to.name === 'Login')) {
    return next({ name: 'Overview' });
  }

  const userRole = localStorage.getItem('role');
  if (to.meta.roles && !to.meta.roles.includes(userRole)) {
    return next({ name: 'Overview' });
  }

  next();
});

export default router;
